import { render } from "./HomeSobre.vue?vue&type=template&id=6932afa8&scoped=true"
import script from "./HomeSobre.vue?vue&type=script&lang=js"
export * from "./HomeSobre.vue?vue&type=script&lang=js"

import "./HomeSobre.vue?vue&type=style&index=0&id=6932afa8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6932afa8"]])

export default __exports__